import { Color } from '@mui/material';
import React, { useMemo } from 'react';
import * as reactCountUp from 'react-countup';
import { Cell, Pie, PieChart } from 'recharts';
import {
  chartHeight,
  chartInnerRadius,
  chartOuterRadius,
  chartWidth,
  countUpTime,
  fadeTimeout,
  saturation,
  SystemStatusCard,
  SystemStatusCardCaption,
  SystemStatusCardText,
} from '../Styles/SystemStatusStyles';

const CountUp = reactCountUp.default;

interface Props {
  title: string;
  data: Array<{ name: string; value: number; color: Color }>;
}

export default function SystemStatusBoxCard({ data, title }: Props): React.JSX.Element {
  const pieData = useMemo(
    () =>
      data.map((d) => {
        const { name, value } = d;
        return {
          name,
          value,
        };
      }),
    [data],
  );

  return (
    <div>
      <SystemStatusCard title={title}>
        <PieChart width={chartWidth} height={chartHeight} style={{ margin: '0 auto', transform: 'rotate(-90deg)' }}>
          <Pie
            data={pieData}
            innerRadius={chartInnerRadius}
            outerRadius={chartOuterRadius}
            paddingAngle={0}
            dataKey={'value'}
          >
            {data.map(({ color }, index: number) => (
              <Cell key={index} fill={color[saturation]} />
            ))}
          </Pie>
        </PieChart>
        <SystemStatusCardText>
          {data.map(({ color, value }, index: number) => (
            <React.Fragment key={index}>
              <span style={{ color: color[saturation] }}>
                <CountUp start={0} end={value} duration={countUpTime / 1000} delay={fadeTimeout / 1000} />
              </span>
              {index === data.length - 1 ? '' : <span>&nbsp;/&nbsp;</span>}
            </React.Fragment>
          ))}
        </SystemStatusCardText>
        <SystemStatusCardCaption>
          {data.map(({ name }, index: number) => (
            <React.Fragment key={index}>
              <span>{name}</span>
              {index === data.length - 1 ? '' : <span>&nbsp;/&nbsp;</span>}
            </React.Fragment>
          ))}
        </SystemStatusCardCaption>
      </SystemStatusCard>
    </div>
  );
}
